define("shared/components/shared/post/secondary/caption-writer/list-item-group", ["exports", "@ember/component", "@ember/template-factory", "@ember/debug", "@ember/service", "@glimmer/component", "shared/utils/constants"], function (_exports, _component, _templateFactory, _debug, _service, _component2, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/service",0,"@glimmer/component",0,"shared/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.isEmpty}}
    <div class="tCW--listItem--topic qa--aiCaption_topicGenerated">
      {{svg-jar "ai" class="o--icon"}}
      <p class="tCW--listItem__label">
        <span>{{t "shared_phrases.quote" text=this.topic}}</span>
        {{#if this.tone}}
          {{! TODO: Parentheses translation string with SVG embedded inside? }}
          {{! template-lint-disable no-bare-strings }}
          <span>
            ({{t "caption_writer.caption_group.prefix"}}
            {{svg-jar this.toneIcon class="o--icon--sm"}}
            {{this.tone}})
          </span>
          {{! template-lint-enable no-bare-strings }}
        {{/if}}
      </p>
  
      {{#if this.isWaitingForCaptions}}
        <span class="o--loading tCW--listItem__spinner"></span>
      {{else if (has-block "expandToggle")}}
        <span class="tCW--listItem__toggleBtn qa--aiCaption_topicGeneratedToggle_btn">
          {{yield to="expandToggle"}}
        </span>
      {{/if}}
    </div>
    <ul class={{concat-classes "tCW--list" (unless @isMinimized "tCW--list--show u--fadeIn")}}>
      {{#each this.generatedCaptions as |generatedCaption|}}
        {{#if (has-block "listItem")}}
          {{yield generatedCaption to="listItem"}}
        {{/if}}
      {{/each}}
    </ul>
  {{/unless}}
  */
  {
    "id": "0d2SohNd",
    "block": "[[[41,[51,[30,0,[\"isEmpty\"]]],[[[1,\"  \"],[10,0],[14,0,\"tCW--listItem--topic qa--aiCaption_topicGenerated\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"ai\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[10,2],[14,0,\"tCW--listItem__label\"],[12],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,2],[\"shared_phrases.quote\"],[[\"text\"],[[30,0,[\"topic\"]]]]]],[13],[1,\"\\n\"],[41,[30,0,[\"tone\"]],[[[1,\"        \"],[10,1],[12],[1,\"\\n          (\"],[1,[28,[35,2],[\"caption_writer.caption_group.prefix\"],null]],[1,\"\\n          \"],[1,[28,[35,1],[[30,0,[\"toneIcon\"]]],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[1,[30,0,[\"tone\"]]],[1,\")\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isWaitingForCaptions\"]],[[[1,\"      \"],[10,1],[14,0,\"o--loading tCW--listItem__spinner\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[48,[30,3]],[[[1,\"      \"],[10,1],[14,0,\"tCW--listItem__toggleBtn qa--aiCaption_topicGeneratedToggle_btn\"],[12],[1,\"\\n        \"],[18,3,null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"ul\"],[15,0,[28,[37,6],[\"tCW--list\",[52,[51,[30,1]],\"tCW--list--show u--fadeIn\"]],null]],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"generatedCaptions\"]]],null]],null],null,[[[41,[48,[30,4]],[[[1,\"        \"],[18,4,[[30,2]]],[1,\"\\n\"]],[]],null]],[2]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@isMinimized\",\"generatedCaption\",\"&expandToggle\",\"&listItem\"],false,[\"unless\",\"svg-jar\",\"t\",\"if\",\"has-block\",\"yield\",\"concat-classes\",\"each\",\"-track-array\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/list-item-group.hbs",
    "isStrictMode": false
  });

  let ListItemGroupComponent = (_class = class ListItemGroupComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      (false && !(Boolean(this.args.topic) && typeof this.args.topic === 'string') && (0, _debug.assert)('A `topic` string argument must be provided', Boolean(this.args.topic) && typeof this.args.topic === 'string'));
      (false && !(Boolean(this.args.generatedCaptionMap)) && (0, _debug.assert)('A `generatedCaptionMap` argument must be provided', Boolean(this.args.generatedCaptionMap)));
    }

    get topic() {
      return this.args.topic.trim();
    }

    get tone() {
      if (this.args.tone === _constants.CaptionWriterTone.Professional) {
        return this.intl.t('caption_writer.form.tones.professional');
      }

      if (this.args.tone === _constants.CaptionWriterTone.Casual) {
        return this.intl.t('caption_writer.form.tones.casual');
      }

      return this.args.tone?.trim();
    }

    get generatedCaptions() {
      return Object.values(this.args.generatedCaptionMap).sort((a, b) => b.createdAt - a.createdAt);
    }

    get isWaitingForCaptions() {
      return this.generatedCaptions.any(generatedCaption => !generatedCaption.generatedText?.length);
    }

    get isEmpty() {
      return !this.isWaitingForCaptions && !this.generatedCaptions.length;
    }

    get toneIcon() {
      const tone = this.tone?.toLocaleLowerCase();
      if (tone === _constants.CaptionWriterTone.Professional) return 'tone-professional';
      if (tone === _constants.CaptionWriterTone.Casual) return 'tone-casual';
      return 'tones';
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = ListItemGroupComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListItemGroupComponent);
});